import React from 'react';
import { Trash, FileSpreadsheet, FileText } from "lucide-react";
import sessionAPI from 'apis/sessionAPI';
import { CHAT_MODE } from 'config';


type OptionButtonProps = {
  itemId: string;
  currentSelectId?: string;
  isDisplayExport: boolean;
  onDelete: (id: string) => void;
}
  
const OptionButton: React.FC<OptionButtonProps> = ({ itemId, currentSelectId, isDisplayExport, onDelete }) => {
  const handleExportExcel = async () => {
    const { error, statusCode } = await sessionAPI.exportSession(itemId, "xls", `session_${itemId}.xlsx`, CHAT_MODE, CHAT_MODE);
    if (statusCode !== 200 && statusCode !== 404) {
      alert(`Excel export failed, ${error}.`);
    }
  };

  const handleExportPdf = async () => {
    const { error, statusCode } = await sessionAPI.exportSession(itemId, "pdf", `session_${itemId}.pdf`, CHAT_MODE, CHAT_MODE);
    if (statusCode !== 200 && statusCode !== 404) {
      alert(`PDF export failed, ${error}.`);
    }
  };

  const handleExportFeedback = async () => {
    const { error, statusCode } = await sessionAPI.exportSession(itemId, "xls", `feedback_session_${itemId}.xlsx`, CHAT_MODE, "feedback");
    if (statusCode !== 200 && statusCode !== 404) {
      alert(`Feedback export failed, ${error}.`);
    }
  };

  const handleDelete = async () => {
    const { error, statusCode } = await sessionAPI.deleteSession(itemId, CHAT_MODE);
    if (statusCode === 200 || statusCode === 204) {
      onDelete(itemId);
      if(itemId === currentSelectId) {
        window.location.reload();
      }
    } else {
      alert(`Delete session failed, ${error}.`);
    }
  };

  return (
    <>
      {
        isDisplayExport && (
          <>
            <button className="flex items-center w-full px-2 py-2 text-sm text-BADBlue bg-transparent hover:bg-BAMPink hover:text-BAWhite" onClick={handleExportExcel}>
              <FileSpreadsheet className="w-4 h-4 mr-2" /> Export Excel
            </button>
            <button className="flex items-center w-full px-2 py-2 text-sm text-BADBlue bg-transparent hover:bg-BAMPink hover:text-BAWhite" onClick={handleExportPdf}>
              <FileText className="w-4 h-4 mr-2" /> Export PDF
            </button>
            <button className="flex items-center w-full px-2 py-2 text-sm text-BADBlue bg-transparent hover:bg-BAMPink hover:text-BAWhite" onClick={handleExportFeedback}>
              <FileText className="w-4 h-4 mr-2" /> Export Feedback
            </button>
            <hr className="my-2 border-gray-300 w-full" />
          </>
        )
      }
      <button className="flex items-center w-full px-2 py-2 text-sm text-red-400 hover:bg-BAMPink hover:text-BAWhite" onClick={handleDelete}>
        <Trash className="w-4 h-4 mr-2" /> Delete
      </button>
    </>
  );
};

export default OptionButton;